/* eslint-disable max-lines */
import { selectCustomerAndRedirect } from 'actions';
import React from 'react';
import { useDispatch } from 'react-redux';

type ComponentProps = {
  toggleModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  selectedModels: string[];
  setSelectedModels: React.Dispatch<React.SetStateAction<string[]>>;
  selectedCustomer: string;
  setSelectedCustomer: React.Dispatch<React.SetStateAction<string>>;

  showPerformance?: boolean;
};

const CategoriesListActionRow: React.FC<ComponentProps> = ({
  toggleModalOpen,
  selectedModels,
  setSelectedModels,
  selectedCustomer,
  setSelectedCustomer,
  showPerformance = false,
}) => {
  const dispatch = useDispatch();

  const handleEditOutcomes = (): void => {
    toggleModalOpen(true);
  };

  const handleClearSelections = (): void => {
    setSelectedModels([]);
    setSelectedCustomer('');
  };

  const handleRedirectOutcomes = (): void => {
    const [ruleId, , domain] = selectedCustomer.split('_');

    if (domain) {
      dispatch(
        selectCustomerAndRedirect({
          domain,
          redirect: {
            routeName: 'rule-group-outcome',
            routeParams: {
              ruleId,
            },
            customerDomain: domain,
          },
        })
      );
    }
  };

  return (
    <>
      <tr className="bg-litlingo-gray-2">
        <th aria-hidden colSpan={1} />
        <th
          colSpan={5}
          className="table-wrapper__new-td table-wrapper__bulk-area bg-litlingo-gray-2 pr-4"
        >
          <div className="table-wrapper__new-cell-content flex flex-row justify-between items-start gap-3 py-2  m-0 h-auto overflow-visible">
            {selectedModels.length > 0 && (
              <div className="w-full flex flex-row items-start gap-2">
                <button
                  type="button"
                  onClick={(): void => handleEditOutcomes()}
                  className="button button--primary h-8 flex justify-center"
                >
                  Add Customer
                </button>
                {showPerformance && (
                  <button
                    type="button"
                    disabled
                    className="button button--secondary font-bold h-8 flex justify-center"
                  >
                    Show Performance
                  </button>
                )}
              </div>
            )}
            {selectedCustomer && (
              <div className="w-full pr-4 flex flex-row items-start gap-2">
                <button
                  type="button"
                  onClick={(): void => handleRedirectOutcomes()}
                  className="button button--primary h-8 flex justify-center"
                >
                  Edit Outcomes
                </button>
              </div>
            )}
            <button
              type="button"
              className="button button--secondary font-bold h-8 flex justify-center whitespace-no-wrap"
              onClick={handleClearSelections}
            >
              Clear Selections
            </button>
          </div>
        </th>
      </tr>
    </>
  );
};

export default CategoriesListActionRow;
